module.exports = __webpack_public_path__ + "static/img/@coupon_thumb.bd44f34.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/@coupon_thumb.png
// module id = bW/m
// module chunks = 0